import { render } from "./MyValues.vue?vue&type=template&id=5645284e&ts=true"
import script from "./MyValues.vue?vue&type=script&lang=ts"
export * from "./MyValues.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__